import { render } from "./SupplierPage.vue?vue&type=template&id=066d7159&ts=true"
import script from "./SupplierPage.vue?vue&type=script&lang=ts"
export * from "./SupplierPage.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__